
namespace TabAurous.Production {

    @Serenity.Decorators.registerClass()
    export class WorkOrderGrid extends _Ext.GridBase<WorkOrderRow, any> {
        protected getColumnsKey() { return 'Production.WorkOrder'; }
        protected getDialogType() { return WorkOrderDialog; }
        protected getIdProperty() { return WorkOrderRow.idProperty; }
        protected getInsertPermission() { return WorkOrderRow.insertPermission; }
        protected getLocalTextPrefix() { return WorkOrderRow.localTextPrefix; }
        protected getService() { return WorkOrderService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
        protected addButtonClick() {

            let now = new Date();
            var voucherNo = FormatHelper.GetVoucherNo(66);
            this.editItem(<WorkOrderRow>{
                VoucherNo: voucherNo,
                CompanyId: Q.Authorization.userDefinition.CompanyId,
                FinancialYearId: Q.Authorization.userDefinition.FinancialYearId,
                UserId: Q.Authorization.userDefinition.UserId,
                EmployeeId:1,
                VoucherTypeId: 66,
                TransDate: now.toDateString()

            });
        }
    }
}